import React from "react";
import PropTypes from "prop-types";
import Carousel from "react-bootstrap/Carousel";

// group items into chunks of `size`
// function chunk(arr, size) {
//   const out = [];
//   for (let i = 0; i < arr.length; i += size) {
//     out.push(arr.slice(i, i + size));
//   }
//   return out;
// }

// sliding window of consecutive pairs, wrapping around (infinite loop)
function buildSlides(items, size = 2) {
  const n = items.length;
  if (n === 0) return [];
  if (n <= size) return [items];
  const slides = [];
  for (let i = 0; i < n; i++) {
    const group = [];
    for (let j = 0; j < size; j++) {
      group.push(items[(i + j) % n]);
    }
    slides.push(group);
  }
  return slides;
}

export default function ProfileCardCarousel({
  title,
  items = [],
  loading,
  emptyText = "Nothing to show yet.",
  intervalMs = 15000,
  cardsPerSlide = 2,
}) {
  if (loading) {
    return (
      <div className="card-soft p-4 icon-list-card">
        <div className="skeleton w-100 h-100" />
      </div>
    );
  }

  const slides = buildSlides(items, cardsPerSlide);

  return (
    <div className="card-soft p-4 icon-list-card">
      <h6 className="fw-bold mb-3">{title}</h6>

      {items.length === 0 && (
        <p className="text-muted mb-0" style={{ fontSize: 13 }}>
          {emptyText}
        </p>
      )}

      {slides.length > 0 && (
        <Carousel
          interval={intervalMs}
          indicators={slides.length > 1}
          controls={slides.length > 1}
          pause="hover"
          fade
        >
          {slides.map((group, slideIdx) => (
            <Carousel.Item key={slideIdx}>
              <div className="profile-carousel-row">
                {group.map((item, idx) => {
                  const img = item.image || item.ImageUrl;
                  return (
                    <div
                      className="profile-carousel-card"
                      key={item.id ?? `${slideIdx}-${idx}`}
                    >
                      <div
                        className="profile-carousel-imgwrap"
                        style={{ backgroundImage: `url(${img})` }}
                      >
                        <img
                          src={img}
                          alt={item.title || "card image"}
                          className="profile-carousel-img"
                        />
                      </div>
                      {item.title && (
                        <div
                          className="profile-carousel-title-bar"
                          title={item.title}
                        >
                          {item?.title?.length > 30
                            ? `${item.title.substring(0, 30)}...`
                            : item.title}
                        </div>
                      )}
                      {item.description && (
                        <p className="profile-carousel-desc">
                          {item.description}
                        </p>
                      )}
                      {item.link && (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-primary profile-carousel-btn"
                        >
                          Learn More
                        </a>
                      )}
                    </div>
                  );
                })}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      )}
    </div>
  );
}

ProfileCardCarousel.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      image: PropTypes.string,
      ImageUrl: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      link: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
  emptyText: PropTypes.string,
  intervalMs: PropTypes.number,
  cardsPerSlide: PropTypes.number,
};
